// Import from package
import React, { Component} from "react";
import { Container, Row, Col, Badge, Button } from "react-bootstrap";


export default class InfoInicio extends Component {

  render() {
    return (
      <>
        <Container className="agent-skill">
          <h1 className="agent-skill-title"><strong>¡Hola!</strong></h1>
          <div className="agent-skill-container" >
            <Row>
              <Col className="p-5" lg={5}>
                <div className="skill-description">
                  <h3 className="d-flex align-items-center">
                    {/* <Badge className="me-3" bg="secondary">{agents[agentIndex].skills[index].skillKey}</Badge> */}
                    <strong>Acerca de InfoValo</strong>
                  </h3>
                  <br></br>Este proyecto es solamente de practica para aplicar conocimientos de Frontend y Backend y no es para uso comercial. <a href="https://lnr.com.ar" target="_blank" rel="noreferrer">Sitio Personal</a>.
            <br></br>Utilizando ReactJS, Firebase, Bootstrap y consumo de api  <a href="https://dash.valorant-api.com/about" target="_blank" rel="noreferrer">Valorant-API</a>.
            <br></br>El template del proyecto es de <a href="https://github.com/ega-erinovian/valorant-agent" target="_blank" rel="noreferrer">ega-erinovian</a>.
            <br></br>
            <br></br>Riot Games, VALORANT y cualquier logotipo relacionado son marcas comerciales o marcas registradas de Riot Games, Inc.
            <br></br>Riot Games, Valorant, and all associated properties are trademarks or registered trademarks of Riot Games, Inc.
            <br></br>Sitio oficial de <a href="https://playvalorant.com/" target="_blank" rel="noreferrer">VALORANT</a>.
            <br></br>
            <Button class="button" className="nav-button ms-2" size="sm"  href="https://playvalorant.com/" target="_blank" rel="noreferrer">
                <strong >Valorant</strong>
              </Button>
              <Button class="button" className="nav-button ms-2" size="sm"  href="https://valorantesports.com/" target="_blank" rel="noreferrer">
                <strong >Valorant Esports</strong>
              </Button>
              <Button class="button" className="nav-button ms-2" size="sm"  href="https://valorant-api.com/" target="_blank" rel="noreferrer">
                <strong >Valorant-API</strong>
              </Button>
              <Button class="button" className="nav-button ms-2" size="sm"  href="https://lnr.com.ar" target="_blank" rel="noreferrer">
                <strong >LNR</strong>
              </Button>
                </div>
              </Col>
              <Col style={{ overflow: "hidden" }}>
                <video preload="true" muted loop autoPlay className="agent-skill-vid" ref='video'>
                  {/* <source src="https://assets.contentstack.io/v3/assets/bltb6530b271fddd0b1/bltefd45731d8f9d9df/6217f2ea910a6c613c73168c/VALORANT_PLAY22_16x9_Target4_v005.mp4" type="video/mp4"/> */}
                  <source src="./assets/video/VCT23_GCC.mp4" type="video/mp4"/>
                </video>               
              </Col>
            </Row>
          </div>
        </Container>
      </>
    );
  }
}
